const EMPTY_VALUE = "—";

export function formatDate(value: string | null | undefined): string {
  if (!value) return EMPTY_VALUE;
  return new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(value));
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  const hasTime =
    date.getHours() !== 0 ||
    date.getMinutes() !== 0 ||
    date.getSeconds() !== 0;
  return new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(hasTime ? { hour: "2-digit" as const, minute: "2-digit" as const } : {}),
  }).format(date);
}

export function formatValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;
  return String(value);
}

export function formatAttachments(values: string[]): string {
  return values.length > 0 ? values.join("\n") : EMPTY_VALUE;
}
